import { useTheme } from '@mui/material';

import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { DistrictVacancies } from 'features/VacanciesModal/components/DistrictVacancies';
import { getToggleButtonSx } from 'features/VacanciesModal/styles';
import { SchoolVacancies } from 'features/VacanciesModal/components/SchoolVacancies';
import { ToggleButtons } from 'sharedComponents/Buttons/ToggleButtons';
import {
  districtOption,
  schoolOption,
  toggleOptions,
  VacancyModalKind,
} from 'features/VacanciesModal/data';
import { VacanciesFormProps } from 'features/VacanciesModal/types';
import { VacanciesModalCTAButtons } from 'features/VacanciesModal/components/VacanciesModalCTAButtons';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { DeletionModal } from 'sharedComponents/Modal/DeletionModal';
import auth from 'utils/auth';

export const VacanciesForm: React.FC<VacanciesFormProps> = ({
  displayPane,
  onSetType,
  onClose,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const theme = useTheme();
  const { setValue } = useFormContext();

  const handleConfirmation = () => setShowConfirmationModal(true);

  const handleSetType = () => {
    if (displayPane.type === 'district') {
      setValue('district_ftes_total', 1);
      onSetType(schoolOption);
    } else {
      setValue('schoolroles', []);
      onSetType(districtOption);
    }

    setShowConfirmationModal(false);
  };

  const handleToggle = () => {
    if (displayPane.type === 'school') {
      return handleConfirmation();
    } else {
      return handleSetType();
    }
  };

  const deletionModalText = auth.isAtsLiteDistrict()
    ? 'Changing to a district-level role will delete school-level vacancies and remove School User access to candidates?'
    : 'Changing to a district-level role will delete school-level vacancies and remove School Admin access to candidates?';

  return (
    <>
      <ToggleButtons
        dataTestId={ATSVacanciesModalTestIds.TOGGLE_BUTTONS}
        options={toggleOptions}
        currentlySelected={displayPane?.type === VacancyModalKind.SCHOOL ? 0 : 1}
        onToggle={handleToggle}
        sx={getToggleButtonSx(theme)}
      />
      {displayPane?.type === VacancyModalKind.DISTRICT && <DistrictVacancies />}
      {displayPane?.type === VacancyModalKind.SCHOOL && <SchoolVacancies />}
      <VacanciesModalCTAButtons onClose={onClose} />

      <DeletionModal
        text={deletionModalText}
        title="Are you sure?"
        open={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        onDelete={handleSetType}
        submitCTAText="Continue"
      />
    </>
  );
};
